export enum ProjectRemoteTypeEnum {
  Managed = 'Managed',
  GitClone = 'GitClone'
}
